import { useState } from 'react';
import { ExpandMoreIcon, ExpandLessIcon } from '@/components/ui/Icons';
import type { ProjectAuthor } from '@/api/client';
import { ExpandableVerticalSlice } from './ExpandableVerticalSlice';
import { highlightPlainText } from '@/utils/highlightSearchTerms';

interface AuthorCellProps {
  authors: ProjectAuthor[];
  searchHighlightWords?: string[];
}

export function AuthorCell({ authors, searchHighlightWords }: AuthorCellProps) {
  const [expanded, setExpanded] = useState(false);

  if (!authors?.length) return <span className="projects-table__empty-value">N/A</span>;

  const authorNames = authors.map((a) => a.name);
  const showExpand = authorNames.length > 2;

  return (
    <div className="projects-table__readers-cell projects-table__author-producer-cell">
      <div className="projects-table__readers-list">
        {authorNames.slice(0, 2).map((name, idx) => (
          <span key={`${name}-${idx}`} className="projects-table__reader-item">
            {searchHighlightWords?.length ? highlightPlainText(name, searchHighlightWords) : name}
          </span>
        ))}
      </div>
      {showExpand ? (
        <ExpandableVerticalSlice expanded={expanded}>
          <div className="projects-table__readers-list">
            {authorNames.slice(2).map((name, idx) => (
              <span key={`${name}-${idx + 2}`} className="projects-table__reader-item">
                {searchHighlightWords?.length ? highlightPlainText(name, searchHighlightWords) : name}
              </span>
            ))}
          </div>
        </ExpandableVerticalSlice>
      ) : null}
      {showExpand && (
        <div className="projects-table__readers-expand">
          {expanded ? (
            <button
              type="button"
              className="projects-table__readers-expand-btn"
              onClick={() => setExpanded(false)}
              title="Свернуть"
              aria-label="Свернуть"
            >
              <ExpandLessIcon size={18} />
            </button>
          ) : (
            <button
              type="button"
              className="projects-table__readers-expand-btn"
              onClick={() => setExpanded(true)}
              title="Показать всех"
              aria-label="Показать всех"
            >
              <ExpandMoreIcon size={18} />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
